module.exports = __webpack_public_path__ + "img/chest.16c551ee.png";